import { createServerFn } from "@tanstack/react-start";
import { Result } from "better-result";
import { z } from "zod/v4";
import {
  fetchJaarplanning,
  saveJaarplanning,
} from "#/modules/les.planning/api.jaarplanning.server";
import {
  MAX_LESSEN,
  MAX_OMSCHRIJVING_LENGTH,
  MAX_OPMERKING_LENGTH,
  MAX_VAKKEN,
  MIN_VAKKEN,
} from "#/modules/les.planning/domain/jaarplanning/vakken";
import { authMiddleware } from "#/modules/util.auth/middleware.auth";
import { toastErrorMiddleware } from "#/modules/util.errors/middleware.toast-errors";
import { translatedApiError } from "#/modules/util.errors/translate";
import { apiEnum } from "#/modules/util.helpers/zod-enum";
import { Beweegthema } from "#/schema.nswag";

const saveSchema = z.object({
  aantalVakken: z.number().int().min(MIN_VAKKEN).max(MAX_VAKKEN),
  vakken: z.array(
    z.object({
      week: z.string().min(1),
      les: z.number().int().min(1).max(MAX_LESSEN),
      vak: z.number().int().min(1).max(MAX_VAKKEN),
      beweegthema: apiEnum(Beweegthema).optional(),
      omschrijving: z.string().trim().min(1).max(MAX_OMSCHRIJVING_LENGTH).optional(),
    }),
  ),
  opmerkingen: z.array(
    z.object({ week: z.string().min(1), tekst: z.string().trim().max(MAX_OPMERKING_LENGTH) }),
  ),
});
export type SaveJaarplanningInput = z.infer<typeof saveSchema>;

export const getJaarplanning = createServerFn({ method: "GET" })
  .middleware([authMiddleware])
  .handler(async () => {
    const result = await fetchJaarplanning();
    if (Result.isError(result)) throw result.error;
    return result.value;
  });

export const saveJaarplanningFn = createServerFn({ method: "POST" })
  .middleware([authMiddleware, toastErrorMiddleware])
  .validator((data: SaveJaarplanningInput) => saveSchema.parse(data))
  .handler(async ({ data }) => {
    const result = await saveJaarplanning(data);
    if (Result.isError(result)) throw translatedApiError(result.error);
    return result.value;
  });
